// src/components/Feed/Styles/AssignTasksDialog.Style.js
// @flow

const assignTasksDialogStyles = {
  flexContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column'
  }),
  dialogFormCtr: (theme) => ({
    height: '90vh',
    maxHeight: 400,
    display: 'flex',
    flexDirection: 'column',
    '&.xlarge': {
      maxHeight: 400
    },
    '&.large': {
      maxHeight: 350
    }
  }),
  grow: (theme) => ({
    flexGrow: 1
  }),
  secondInput: (theme) => ({
    marginTop: theme.spacing(2)
  }),
  error: (theme) => ({
    color: theme.palette.error.main || '#f44336'
  }),
  container: (theme) => ({
    position: 'relative'
  }),
  paper: (theme) => ({
    marginTop: theme.spacing(1),
    maxHeight: 300,
    overflowY: 'auto'
  }),
  inputRoot: (theme) => ({
    // old MUI v4 style for textfields, if needed
  }),
  inputInput: (theme) => ({
    // ...
  })
};

export default assignTasksDialogStyles;